/* @flow */

import { Settings } from 'luxon';
import * as React from 'react';

import useEventTimezone from 'src/shared/domain/event/hook/useEventTimezone';
import useMembershipTimezone from 'src/shared/domain/membership/hook/useMembershipTimezone';

export default function useTimezone() {
  const membershipTimezone = useMembershipTimezone();
  const eventTimezone = useEventTimezone();

  const timezone = membershipTimezone || eventTimezone;

  React.useEffect(() => {
    Settings.defaultZoneName = timezone;
  }, [timezone]);

  return timezone;
}
